import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Enheter from './pages/Enheter';
import KontantAvstemming from './pages/KontantAvstemming';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/enheter" element={<Enheter />} />
        <Route path="/kontant-avstemming" element={<KontantAvstemming />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
